import React from "react";
import PropTypes from "prop-types";
import DisplayAdOnPage from "shared/components/DisplayAdOnPage";
import { FORMATS_KEYS } from "shared/modules/onpageads/constants";

class DisplayAd extends React.Component {
	static propTypes = {
		format: PropTypes.oneOf(Object.values(FORMATS_KEYS)).isRequired,
		refresh: PropTypes.bool,
	};

	static defaultProps = {
		refresh: false,
	};

	shouldComponentUpdate() {
		// once this renders, it should stay that way. so go ahead and tell it to GFY
		return false;
	}

	render() {
		return <DisplayAdOnPage format={this.props.format} refresh={this.props.refresh} />;
	}
}


export default DisplayAd;



// WEBPACK FOOTER //
// ./src/shared/components/DisplayAd.jsx